import {$t} from "@/i18n";
import {cleanNumber, formatMoney, formatNumber, formatPercent, formatSysDate, parseSysDate} from "@/plugins/formatting";
import axios from 'axios'
import {get} from "@/helpers/get-set";

import {getManifestData} from "@/views/AppStore/app-store-manifest";

export const getCookie = function(name) {
    let match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
    return match ? decodeURIComponent(match[3]) : null;
};

export const setCookie = function(name, value, days, path) {
    let date, expires;
    if (path == null) path = "/";
    expires = "";
    if (days) {
        date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toGMTString();
    }
    document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=" + path;
    return true;
};
export const getCurrentBrowserName = function() {
    if (navigator.userAgent.indexOf("Chrome") !== -1) {
        return "chrome";
    }
    if (navigator.userAgent.indexOf("Firefox") !== -1) {
        return "firefox";
    }
    return "-";
};

export const parseRate = (str, auto_corrector, clean_number = true) => {
    if (!str) {
        return null;
    }
    let str_c = str
    if (clean_number) {
        str_c = cleanNumber(str);
    }

    const regex1 = /^(\d+([.,]\d+)?)(%)?$/g;
    const m = regex1.exec(str_c);
    if (m) {
        const n = m[1].replace(",", ".");
        if (m[3] === "%") {
            return parseFloat(n) / 100;
        } else {
            const flt = parseFloat(n);
            if (auto_corrector) {
                if (flt >= 1) {
                    return flt / 100;
                } else {
                    return flt;
                }
            } else {
                return flt;
            }
        }
    }
    return null;
};

export const getTranslatedProductFieldSource = (source) => {
    return $t(getRegionAppTitle(source)) || $t(source)
}
export const getFormattedProductFieldLabel = (product_field) => {
    let name = ""
    if (product_field.value) {
        let val = product_field.value

        if (product_field.type === 'vat') {
            let _rate = parseRate(product_field.value, false, false);
            val = _rate !== null ? formatNumber(_rate * 100) + "%" : "-"
        }
        name = val + " / ";
    }

    name += product_field.label;
    if (product_field.code) {
        name += " / " + product_field.code;
    }

    if (product_field.source) {
        name += " / " + getTranslatedProductFieldSource(product_field.source) + "";
    }
    return name;
}

export const getRegionAppTitle = (appName, regionCode, company) => {
    const regionTitles = getManifestData(appName, "title_region", company)
    const defaultTitle = getManifestData(appName, "title", company)
    if (!regionTitles) {
        return defaultTitle
    }

    const regionTitle = regionTitles[regionCode]
    return regionTitle ? regionTitle : defaultTitle
}

export const updateMapList = (map, key, item) => {
    if (!map.get(key)) {
        if (Array.isArray(item)) {
            map.set(key, [...item]);
        } else {
            map.set(key, [item]);
        }
    } else {
        const value = map.get(key)

        if (Array.isArray(item)) {
            value.push(...item);
        } else {
            value.push(item);
        }
        map.set(key, value)
    }
    return map;
};

export const downloadFile = async (endpoint, file) => {
    let endUrl = file.id !== 0 ? file.id : "?temp_name=" + encodeURIComponent(file.temp_name)
    let url = `/${endpoint}/${endUrl}`

    const response = await axios({
        url: url,
        method: 'GET',
        responseType: 'blob',
    })

    const type = response.headers['content-type']
    if(type === 'application/x-link') {
        return window.open(await response.data.text(), '_blank')
    }
    const blob = new Blob([response.data], {type: type, encoding: 'UTF-8'})
    const link = document.createElement('a')
    link.href = window.URL.createObjectURL(blob)
    link.download = file.file_name
    link.click()
}

function convertToValidFilename(string) {
    return (string.replace(/[\/|\\:*?"<>]/g, " "));
}

export const downloadFiles = async (url, fileName, files) => {
    fileName = convertToValidFilename(fileName + '.zip')

    const response = await axios({
        url: url,
        method: 'POST',
        responseType: 'blob',
        data: {
            files: files
        }
    })

    const type = response.headers['content-type']
    const blob = new Blob([response.data], {type: type, encoding: 'UTF-8'})
    const link = document.createElement('a')
    link.href = window.URL.createObjectURL(blob)
    link.download = fileName
    link.click()
}

export const customGroupFunction = (input_list, keyGetter, minSize, nosort = false, sort_by = "due_date", naturalSort = false) => {
    const re_map = new Map();
    const map = new Map();
    let list = [...input_list];
    if (!nosort) {
        list.sort((a, b) => {
            const aValue = get(a, sort_by)
            const bValue = get(b, sort_by)

            if (naturalSort) {
                return aValue.localeCompare(bValue)
            }

            return aValue > bValue ? 1 : -1
        });
    }
    list.forEach(item => {
        const key = keyGetter(item);
        updateMapList(map, key, item);
    });
    if (minSize) {
        let real_groups_count = 0;
        map.forEach((group, group_key) => {
            if (group.length >= minSize) {
                updateMapList(re_map, group_key, group);
                real_groups_count++;
            } else {
                const ungroup_key = "ungrouped_" + real_groups_count;
                updateMapList(re_map, ungroup_key, group);
            }
        });
        return re_map;
    }
    return map;
};

export const omit = (obj, omitKeys) => {
    // Omit listed keys from object. Functional.
    return Object.keys(obj).reduce((result, key) => {
        if (!omitKeys.includes(key)) {
            result[key] = obj[key];
        }
        return result;
    }, {});
};

export const intersection = (a, b) => {
    let result = new Array();

    for (let i = 0; i < a.length; i++) {
        for (let j = 0; j < b.length; j++) {
            if (a[i] == b[j] && result.indexOf(a[i]) == -1) {
                result.push(a[i]);
            }
        }
    }
    return result;
};

export const deepClone = (aObject, def) => {
    if (!aObject) {
        if (def) return def;
        return aObject;
    }

    let v;
    let bObject = Array.isArray(aObject) ? [] : {};
    for (const k in aObject) {
        if (Object.prototype.hasOwnProperty.call(aObject, k)) {
            v = aObject[k];
            bObject[k] = (v === null) ? null : (typeof v === "object") ? deepClone(v) : v;
        }
    }
    return bObject;
};

export const toType = function (obj) {
    /**
     * Better type function
     *      toType(undefined) === 'undefined'
     *      toType(null) === 'null'
     *      toType('string') === 'string'
     *      toType({}) === 'object'
     *      toType([]) === 'array'
     *      toType(0) === 'number'
     *      toType(false) === 'boolean'
     *      toType(Date) === 'date'
     *      toType(myFunction) === 'function'
     */
    return ({}).toString.call(obj).match(/\s([a-z|A-Z]+)/)[1].toLowerCase();
}
export const isFunction = function (val) {
    return toType(val) === 'function'
}
export const isObject = function (val) {
    return toType(val) === 'object'
}
export const isArray = function (val) {
    return toType(val) === 'array'
}

export const translateCalculateByType = function (item) {
    if (item.type.startsWith("custom_field/")) {
        return $t("Field: ") + (item.type_args ? item.type_args : item.type)
    } else {
        switch (item.type) {
            case "fixed_price":
                return $t("Fixed price");
            case "total_hours":
                return $t("Total hours");
            case "normal_hours":
                return $t("Normal hours");
            case "extra_hours":
                return $t("Extra hours");
        }
    }
    return item.type;
};

export const translateUnit = function (product) {
    switch (product.unit) {
        case "year":
            return $t("Year");
        case "quarter":
            return $t("Quarter");
        case "month":
            return $t("Month");
        case "hour":
            return $t("Hour");
        case "piece":
            return $t("Piece");
    }
    return product.unit;
};

export const chooseStringByCount = function (count, single, plural) {
    return count === 1 ? single : plural
}

export const filterNumber = e => {
    e = e || window.event;
    var charCode = (typeof e.which == "undefined") ? e.keyCode : e.which;
    var charStr = String.fromCharCode(charCode);
    if (!/[0-9,.-]/.test(charStr)) {
        e.preventDefault();
        e.stopPropagation()
        return false;
    }
}

export const getTimezoneOffset = (timeZone) => {
    const timeZoneName = Intl.DateTimeFormat('ia', {
        timeZoneName: 'shortOffset',
        timeZone,
    })
        .formatToParts()
        .find((i) => i.type === 'timeZoneName')?.value
    if (!timeZoneName) {
        return 0
    }

    const offset = timeZoneName.slice(3)
    if (!offset) return null

    const matchData = offset.match(/([+-])(\d+)(?::(\d+))?/)
    if (!matchData) return null

    const [, positiveSymbol, hour, minute] = matchData

    let result = parseInt(hour) * 60
    if (minute) result += parseInt(minute)

    if (positiveSymbol === '-') {
        result *= -1
    }

    return result
}

export const getEndOfWeek = (date, weeks) => {
    return formatSysDate(
        parseSysDate(date)
            .calcAddDays((weeks - 1) * 7)
            .calcWeekEnd()
    );
}

export const isPwa = () => {
    return ["fullscreen", "standalone", "minimal-ui"].some(
        (displayMode) => window.matchMedia('(display-mode: ' + displayMode + ')').matches
    );
}